/**
 * This function returns a boolean that indicates if navigator.userAgent
 * matches some standard mobile device naming conventions.
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent
  )
}

// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== 'undefined'
// Chrome 1 - 71
export const isSafari = window.safari !== undefined
export const isChrome = !!window.chrome && navigator.userAgent.indexOf('Chrome') !== -1
export const isIE = false || !!document.documentMode
export const isEdge = !isIE && !!window.StyleMedia
